import { render, staticRenderFns } from "./deanSidemenuColumnItem.vue?vue&type=template&id=27f56d0e&scoped=true"
import script from "./deanSidemenuColumnItem.vue?vue&type=script&lang=ts"
export * from "./deanSidemenuColumnItem.vue?vue&type=script&lang=ts"
import style0 from "./deanSidemenuColumnItem.vue?vue&type=style&index=0&id=27f56d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f56d0e",
  null
  
)

export default component.exports